<div class=" container card h-100 d-flex mx-auto max-w-7xl text-center p-5 mt-5">
    <button type="button" class="btn btn-sm btn-secondary col-2  mb-5" [routerLink]="['/market-place']">
        Go Back
    </button>
    User-Agreement in progress .....
</div>